var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "studio_icon 3",
    clipPath: "url(#clip0_4660_139574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 196",
    d: "M48.2571 22.5614C48.2571 17.3185 52.5072 13.0684 57.7501 13.0684H149.55C180.768 13.0684 206.076 38.3761 206.076 69.5948V69.5948C206.076 100.814 180.768 126.121 149.55 126.121H127.167C83.5861 126.121 48.2571 90.7923 48.2571 47.2117V22.5614Z",
    fill: "url(#paint0_linear_4660_139574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 195",
    d: "M209.354 209.557C217.327 220.096 209.809 235.21 196.594 235.21L120.137 235.21C115.365 235.21 110.842 233.08 107.802 229.401L39.7409 147.019C37.3944 144.179 36.0999 140.616 36.0761 136.932L35.3667 27.3357C35.2671 11.9409 54.8386 5.30149 64.1266 17.5793L209.354 209.557Z",
    fill: "url(#paint1_linear_4660_139574)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4660_139574",
    x1: 198.347,
    y1: 29.8898,
    x2: 85.7108,
    y2: 70.7641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4660_139574",
    x1: 100.425,
    y1: 65.4299,
    x2: 16.8387,
    y2: 178.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940808,
    stopColor: "#FBA0C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4660_139574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemixIcon);
export default __webpack_public_path__ + "static/media/remix-icon.30058b2951f503bae1720b296223b9b9.svg";
export { ForwardRef as ReactComponent };